import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pc login" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      class: "login-contain",
      model: _ctx.loginFormData,
      name: "account",
      "label-col": { span: 4 },
      "wrapper-col": { span: 18 },
      autocomplete: "off",
      onFinish: _ctx.onFinish,
      onFinishFailed: _ctx.onFinishFailed
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          label: "账号",
          name: "account",
          rules: _ctx.loginFormRules.account
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.loginFormData.account,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginFormData.account) = $event)),
              placeholder: "手机号/uuid"
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["rules"]),
        _createVNode(_component_a_form_item, {
          label: "密码",
          name: "password",
          rules: _ctx.loginFormRules.password
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              value: _ctx.loginFormData.password,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginFormData.password) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["rules"]),
        _createVNode(_component_a_form_item, { "wrapper-col": { offset: 4, span: 18 } }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode("立即登录")
              ]),
              _: 1
            }),
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "onFinish", "onFinishFailed"])
  ]))
}